import React from 'react';

interface MaintenancePageProps {
  messageAr: string;
  messageEn: string;
}

export default function MaintenancePage({ messageAr, messageEn }: MaintenancePageProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-blue-50 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-8 py-12 text-center">
            <div className="inline-flex items-center justify-center w-24 h-24 bg-white rounded-full mb-6 shadow-lg">
              <i className="ri-tools-line text-5xl text-orange-500"></i>
            </div>
            <h1 className="text-4xl font-bold text-white mb-2">
              Under Maintenance
            </h1>
            <h2 className="text-3xl font-bold text-white" dir="rtl">
              تحت الصيانة
            </h2>
          </div>

          {/* Content Section */}
          <div className="px-8 py-12 space-y-8">
            {/* Arabic Message */}
            {messageAr && (
              <div className="text-center" dir="rtl">
                <div className="inline-flex items-center gap-2 mb-4">
                  <div className="w-12 h-0.5 bg-orange-500"></div>
                  <i className="ri-message-3-line text-2xl text-orange-500"></i>
                  <div className="w-12 h-0.5 bg-orange-500"></div>
                </div>
                <p className="text-xl text-gray-700 leading-relaxed font-arabic whitespace-pre-line">
                  {messageAr}
                </p>
              </div>
            )}

            {/* Divider */}
            <div className="flex items-center justify-center gap-4">
              <div className="h-px bg-gray-200 flex-1"></div>
              <i className="ri-global-line text-2xl text-gray-400"></i>
              <div className="h-px bg-gray-200 flex-1"></div>
            </div>

            {/* English Message */}
            {messageEn && (
              <div className="text-center">
                <div className="inline-flex items-center gap-2 mb-4">
                  <div className="w-12 h-0.5 bg-blue-500"></div>
                  <i className="ri-message-3-line text-2xl text-blue-500"></i>
                  <div className="w-12 h-0.5 bg-blue-500"></div>
                </div>
                <p className="text-xl text-gray-700 leading-relaxed whitespace-pre-line">
                  {messageEn}
                </p>
              </div>
            )}
          </div>

          {/* Footer Section */}
          <div className="bg-gray-50 px-8 py-8 border-t border-gray-100">
            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-gray-600">
              {/* Contact Info */}
              <div className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-2xl text-orange-500"></i>
                <span className="text-sm">
                  <span className="font-arabic">للاستفسار:</span> / For inquiries
                </span>
              </div>
              
              {/* Animated Loading */}
              <div className="flex items-center gap-2">
                <div className="flex gap-1">
                  <div className="w-2 h-2 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                  <div className="w-2 h-2 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                  <div className="w-2 h-2 bg-orange-500 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                </div>
                <span className="text-sm font-medium text-gray-700">
                  <span className="font-arabic">جاري العمل</span> / Working on it
                </span>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="mt-6 w-full max-w-md mx-auto">
              <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-orange-500 to-blue-500 rounded-full animate-pulse"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Logo/Branding (Optional) */}
        <div className="text-center mt-8">
          <div className="inline-flex items-center gap-2 text-gray-500">
            <i className="ri-ship-line text-3xl"></i>
            <span className="text-sm">FireBoat</span>
          </div>
        </div>
      </div>
    </div>
  );
}
